import reviewflifyImage from '../assets/reviewflify.png'
import wordlyNative from '../assets/wordly-native.png'
import amazonBestsellerReader from "../assets/amazon-bestseller.png"
import reviewflifyImageProject from "../assets/reviewflify-2.png"


class Project {
  constructor(name, image, secondImage, skills, shortDescription) {
    this.name = name;
    this.image = image;
    this.secondImage = secondImage;
    this.skills = skills;
    this.shortDescription = shortDescription;
  }
}

export const projectList = [
  new Project(
    "Reviewflify",
    reviewflifyImage,
    reviewflifyImageProject,
    "HTML, CSS, MaterialUI, React.js, Node.js, MySQL",
    "Reviewflify is a dynamic web application that allows users to post, update, delete, and view movie reviews, utilizing a React frontend and a Node.js with Express backend supported by a MySQL database. It offers an intuitive interface with Material-UI, API interaction via Axios, and secure CORS configurations for a comprehensive review management experience."
  ),
  new Project(
    "Wordly Clone Native",
    wordlyNative,
    null,
    "Javascript, Typescript, React Native",
    "This React Native app lets you play a Wordle clone, a word guessing game with color-coded hints, and keeps track of your wins, losses, and games played. You can even share your results with friends."
  ),
  new Project(
    "Amazon Bestseller Reader",
    amazonBestsellerReader,
    null,
    "Python",
    "This Python project scrapes Amazon's 'electronics and photo category' for the top ten titles and prices, then converts that data into an mp3 announcement using text-to-speech. Inspired by a COVID-19 audio alert mashup, it delivers product information through sound."
  )
];

